import Vue from 'vue'
import App from './App.vue'
import router from './router/index';
import 'fullpage-vue/src/fullpage.css'
import VueFullPage from 'fullpage-vue'
import store from './store';
import apiService from '@/api/index'
Vue.prototype.$api = apiService;
Vue.use(VueFullPage)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
	// 如果路由元信息中有title属性，则用它作为页面标题
	if (to.meta && to.meta.title) {
		document.title = to.meta.title
	}else{
		document.title = 'BioTrack Capital';
	}
	next()
})
new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')
